import { forwardRef, type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import InputError from '../Error';
import styles from '../Form.module.css';

export interface CheckboxProps
  extends Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'type'> {
  label?: string;
  children?: ReactNode;
  error?: string;
  className?: string;
  inputClassName?: string;
  mr?: string;
}
const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ name, id, label, error, checked, children, onChange, className, inputClassName, mr, ...rest }, ref) => {
    return (
      <>
        <fieldset className={twMerge(['relative', className])}>
          <legend className='sr-only'>{name}</legend>
          <div className='relative flex items-start'>
            <div className='flex items-center h-5'>
              <input
                {...rest}
                id={id || name}
                className={twMerge(['mr-2 h-5 w-5 form-checkbox', error && styles['form-input-error'], inputClassName])}
                ref={ref}
                aria-describedby={name}
                name={name}
                onChange={onChange}
                checked={checked}
                type='checkbox'
              />
              {label && (
                <label className='cursor-pointer ml-2' htmlFor={id || name}>
                  {label}
                </label>
              )}
            </div>
            <div className='ml-3 text-sm'>
              <p id='comments-description' className='text-gray-500'>
                {children}
              </p>
            </div>
          </div>
        </fieldset>
        {error && <InputError>{error}</InputError>}
      </>
    );
  }
);

export default Checkbox;
